module.exports = __webpack_public_path__ + "img/logo_sollers.927bf69b.svg";